import styled from '@emotion/styled';

export const Wrapper = styled.div`
  display: flex;
  align-items: center;

  position: relative;

  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 15px;

  height: 90px;
  width: 100%;
  max-width: ${props => props.theme.layout.containerWidth.l};

  img {
    margin: 0px;
  }

  @media (max-width: ${props => props.theme.breakpoints.l}) {
    padding: 10px 20px;
    height: auto;
    margin-bottom: 5px;
    background-color: ${props => props.theme.colors.white};
  }
`;

export const Logo = styled.div`
  width: 225px;
  margin-right: 30px;
  object-fit: contain;

  @media (max-width: ${props => props.theme.breakpoints.s}) {
    width: 180px;
    margin-right: 20px;
  }
`;

export const FlagsBanner = styled.div`
  width: 100%;
  height: auto;
  object-fit: contain;
`;